import UnifiedEventDropdown from 'report-customization-components/components/unified-event-dropdown/UnifiedEventDropdown';
import { getIsReportValidForUnifiedEventDropdown } from 'report-customization-components/components/unified-event-dropdown/utils';
import { ReportOptionsCategories } from '../singleReportViewer/fullPage/sidebar/categorized/ReportOptionCategory';
import { jsx as _jsx } from "react/jsx-runtime";
const UnifiedEventQLEventEditor = props => /*#__PURE__*/_jsx(UnifiedEventDropdown, Object.assign({}, props));
UnifiedEventQLEventEditor.isUsableForReport = report => getIsReportValidForUnifiedEventDropdown({
  report
});
UnifiedEventQLEventEditor.category = ReportOptionsCategories.Define;
export default UnifiedEventQLEventEditor;